import React, { Component } from 'react';
import PropTypes from 'prop-types';
import formattedDate from 'lib/common/formattedDate';

class PerformanceSelector extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let performanceId = parseInt(event.target.value, 10);
    const ret = this.props.onChangePerformance(performanceId);

    // Only cancel if returned value is explicitly `false`
    return (ret === false) ? false : undefined;
  }

  render() {
    let { performances, currentPerformanceId } = this.props;
    return performances.length > 1 ? (
      <div className="syos-performance-selector">
        <label
          className="syos-performance-selector__label"
          htmlFor="syos-performance-selector"
        >
          Select a different performance:
        </label>
        <select
          className="syos-performance-selector__select"
          value={currentPerformanceId}
          onChange={this.handleChange}
          id="syos-performance-selector"
        >
          <optgroup label="Select a performance">
            {performances.map((performance, idx) => {
              return (
                <option value={performance.perf_no} key={idx}>
                  {formattedDate(performance.perf_dt || performance.perf_date)}
                </option>
              );
            })}
          </optgroup>
        </select>
      </div>
    ) : null;
  }
}

PerformanceSelector.propTypes = {
  currentPerformanceId: PropTypes.number.isRequired,
  onChangePerformance: PropTypes.func.isRequired,
  performances: PropTypes.array
};

export default PerformanceSelector;



// WEBPACK FOOTER //
// ./src/javascripts/components/PerformanceSelector.js